/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ConnectInputs */

const en_common_connect = /** @type {(inputs: Common_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect`)
};

const es_common_connect = /** @type {(inputs: Common_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectar`)
};

/**
* | output |
* | --- |
* | "Connect" |
*
* @param {Common_ConnectInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_connect = /** @type {((inputs?: Common_ConnectInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ConnectInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_connect(inputs)
	return en_common_connect(inputs)
});